import { AirReservationList } from '../components/AirReservationList';

/** "Rezervasyon Listesi" — reservations still in progress (not yet ticketed). Fixed to
 *  `status: 'Prebooked'`; see components/AirReservationList.tsx for the shared
 *  implementation with "Bilet Listesi" (`status: 'Booked'`, pages/AirTicketsPage.tsx). */
export default function AirReservationsPage() {
  return <AirReservationList status="Prebooked" title="Uçak Rezervasyon Listesi" />;
}
